import React from 'react';
import './PageNotFound.css';
import { Image } from 'semantic-ui-react';
import Strings from '../common/Strings';
import { history } from '../helpers';

export const PageNotFound = () => {
  return (
    <div className="page-not-found-root">
      <div className="page-not-found-container">
        <Image className="page-not-found-image" src="/sad.png" />
        <p className="page-not-found-title">{Strings.PAGE_NOT_FOUND.title}</p>
        <div className="page-not-found-box-container">
          <p className="page-not-found-header">
            {Strings.PAGE_NOT_FOUND.header}
          </p>
          <p className="page-not-found-body">{Strings.PAGE_NOT_FOUND.body1}</p>
          <p className="page-not-found-body">{Strings.PAGE_NOT_FOUND.body2}</p>
          <p className="page-not-found-return" onClick={() => history.goBack()}>
            {Strings.PAGE_NOT_FOUND.return}
          </p>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/PageNotFound.js